import { CustomMotion } from './CustomMotion';

export default class GreatStrengthDamageMotion extends CustomMotion {
  key = 'great_strength_damage_motion';
  frames = 25;
  transforms = {
    // convert this to 0-1 based on 65536 for 16.16 and 20 for twips
    1: [65475 / 65536, 666 / 65536, -3812 / 65536, 9026 / 65536, 5 / 20, 521 / 20],
    11: [63672 / 65536, 15310 / 65536, -5738 / 65536, 7944 / 65536, 33 / 20, 469 / 20],
    12: [64386 / 65536, -12010 / 65536, -1998 / 65536, 9595 / 65536, -4 / 20, 572 / 20],
    13: [64343 / 65536, 12238 / 65536, -5381 / 65536, 8191 / 65536, 29 / 20, 479 / 20],
    14: [64473 / 65536, -11651 / 65536, -2088 / 65536, 9579 / 65536, 1 / 20, 570 / 20],
    15: [63875 / 65536, 1619 / 65536, -3391 / 65536, 9195 / 65536, 16 / 20, 517 / 20],
    17: [62269 / 65536, -869 / 65536, -1181 / 65536, 26300 / 65536, 5 / 20, 368 / 20],
    18: [59049 / 65536, -825 / 65536, 19 / 65536, 84754 / 65536, 10 / 20, -171 / 20],
    19: [55827 / 65536, -779 / 65536, 76 / 65536, 90425 / 65536, 25 / 20, -223 / 20],
    20: [66646 / 65536, -930 / 65536, 57 / 65536, 68230 / 65536, -20 / 20, -18 / 20],
    21: [82032 / 65536, -1144 / 65536, 47 / 65536, 55493 / 65536, -85 / 20, 100 / 20],
    22: [70112 / 65536, -978 / 65536, 72 / 65536, 84569 / 65536, -33 / 20, -168 / 20],
    23: [80025 / 65536, -1116 / 65536, 47 / 65536, 55175 / 65536, -74 / 20, 103 / 20],
    24: [63559 / 65536, -887 / 65536, 62 / 65536, 72750 / 65536, 1 / 20, -59 / 20],
    25: [65536 / 65536, 1 / 65536, -859 / 65536, 65527 / 65536, 2 / 20, 3 / 20],
  };
  // characterAnimation = ANIMATIONS.HURT_LITE;
  characterAnimationFreeze = true;
}
